import React, {FC} from "react";
import {makeStyles} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles({
  infoAlert: {
    "& .MuiAlert-icon": {
      color: "#B8E7FB",
    },
    backgroundColor: "#233145",
  },
});

type PropsType = {
  show: boolean
  content: any
}

const NoHaveData: FC<PropsType> = ({show, content}) => {
  const classes = useStyles()

  return (
    <Alert
      style={{display: show ? 'flex' : 'none'}}
      className={classes.infoAlert}
      severity="info"
    >
      {content}
    </Alert>
  )
}

export default NoHaveData